<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
        <el-form-item label="货代编码:" prop="forwarderCode">
          <el-input v-model="searchForm.forwarderCode" clearable placeholder="货代编码" />
        </el-form-item>
        <el-form-item label="公司名称:" prop="companyName">
          <el-input v-model="searchForm.companyName" clearable placeholder="公司名称" />
        </el-form-item>
        <el-form-item label="维护时间:" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            clearable
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD"
            style="width: 250px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="isLoading" @click="searchQueryList">
            搜索
          </el-button>
          <el-button type="default" :loading="isLoading" @click="resetForm">
            重置
          </el-button>
        </el-form-item>
      </el-form>

      <div class="mb-10">
        <el-button type="primary" @click="openAddDialog">
          新建货代信息
        </el-button>
      </div>

      <div v-loading="isLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="date" label="操作" width="130" align="left" fixed="left">
            <template v-slot="{row}">
              <el-button type="text" @click="openEditDialog(row)">
                编辑
              </el-button>
              <el-button type="text" :class="row.isEnabled ? 'danger-text' : ''" @click="toggleStatus(row)">
                {{ row.isEnabled ? '停用' : '启用' }}
              </el-button>
              <el-button type="text" class="danger-text" @click="deleteRow(row)">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="forwarderCode" label="货代编码" align="left" />
          <el-table-column prop="companyName" label="公司名称" align="left" />
          <el-table-column prop="contactPerson" label="联系人" align="left" width="130" />
          <el-table-column prop="phoneNumber" label="电话" align="left" width="120" />
          <el-table-column prop="email" label="邮箱" align="left" width="150" />
          <el-table-column prop="address" label="地址" align="left" width="150" />
          <el-table-column prop="isEnabled" label="当前状态" align="left" width="90">
            <template v-slot="{row}">
              {{ row.isEnabled ? '启用' : '停用' }}
            </template>
          </el-table-column>
          <el-table-column prop="updateByName" label="维护人" align="left" width="90" />
          <el-table-column prop="updateTime" label="最后维护时间" align="left" width="150" />
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10, 20, 30, 40]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </div>

    <addDialog ref="addDialog" @on-ok="searchQueryList" />

    <editDialog ref="editDialog" @on-ok="queryData" />
  </div>
</template>

<script>
import { freightForwardergetList, freightForwarderupdate, freightForwarderdelete } from '@/API/international';
import addDialog from './addDialog.vue';
import editDialog from './editDialog.vue';
import dayjs from 'dayjs';

export default {
  components: {
    addDialog,
    editDialog
  },

  data () {
    return {
      tableData: [],
      searchForm: {
        forwarderCode: '',
        companyName: '',
        date: []
      },
      isLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },

  created () {
    this.queryData();
  },

  methods: {

    searchQueryList () {
      this.page.currentPage = 1;
      this.queryData();
    },

    getRangeTime (array) {
      if (array && array.length === 2) {
        return {
          createBeginTime: dayjs(array[0]).format('YYYY-MM-DD 00:00:00'),
          createEndTime: dayjs(array[1]).format('YYYY-MM-DD 23:59:59')
        };
      }
      return { createBeginTime: '', createEndTime: '' };
    },

    queryData () {
      this.isLoading = true;
      let params = {
        forwarderCode: this.searchForm.forwarderCode,
        companyName: this.searchForm.forwarderCode,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
        ...this.getRangeTime(this.searchForm.date)
      };

      freightForwardergetList(params).then((res) => {
        this.isLoading = false;
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.list;
          this.page.total = data.total;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.queryData();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChange (val) {
      this.page.currentPage = 1;
      this.queryData();
    },

    // 改变当前页码
    handerCurrentChange (val) {
      this.queryData();
    },

    openAddDialog () {
      this.$refs.addDialog.openDialog();
    },

    openEditDialog ({ id }) {
      this.$refs.editDialog.openDialog(id);
    },

    deleteRow ({ id }) {
      this.$confirm(`您确定要删除吗？`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          freightForwarderdelete({ id }).then((res) => {
            let { status, err } = res.data;
            if (status === '200') {
              this.$message.success(err);
              this.queryData();
            }
          }).catch(() => {
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },

    toggleStatus (row) {
      console.log(row);
      this.$confirm(`您确定要${row.isEnabled ? '停' : '启'}用吗？`, '提示', {
        confirmButtonText: `${row.isEnabled ? '停' : '启'}用`,
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.isEnabled = !row.isEnabled;
          freightForwarderupdate(row).then((res) => {
            let { status, err } = res.data;
            if (status === '200') {
              this.$message.success(err);
              this.queryData();
            }
          }).catch(() => {
            this.isLoading = false;
          });
        })
        .catch(() => {});
    }
  }

};
</script>

<style scoped>
.mb-10{
  margin-bottom: 10px;
}

.danger-text{
  padding: 2px;
  color: #F56C6C;
}
</style>
